"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.StickyContainer = exports.Sticky = undefined;

var _Sticky = require("./Sticky");

var _Sticky2 = _interopRequireDefault(_Sticky);

var _Container = require("./Container");

var _Container2 = _interopRequireDefault(_Container);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.Sticky = _Sticky2.default;
exports.StickyContainer = _Container2.default;
exports.default = _Sticky2.default;


/*****************
 ** WEBPACK FOOTER
 ** ./~/react-sticky/lib/index.js
 ** module id = 267
 ** module chunks = 0
 **/